
import React from 'react';
import DivContainerBody from '../../../../../components/DivContainerBody';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import routes from '../../../../../Routes/routes';
import HeadTittle from '../../../../../components/HeadTittle';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import CommonCafeteriaApp from "../Functionality/CommonCafeteriaApp";
import CafeteriaFields from "./CafeteriaFields";
import CafeteriaSummary from "./CafeteriaSummary";
import CafeteriaMap from "./CafeteriaMap";
import CafeteriaAccess from "./CafeteriaAccess";
import CreateCafeteriaApp from "../Functionality/CreateCafeteriaApp";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CreateCafeteria = () => {
    const props = CommonCafeteriaApp();

    const {
        t,
        navigate,             // React router navigation
        dispatch,             // Redux dispatch function
        getListStatus,
        item,
        setItem,
        handleChange,
        disabled,
        emptyFields,
        setEmptyFields,
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        errorCode,
        errorName,
        dayArray,
        setDayArray,
        deviceList,
        setDeviceList,
        deviceSelectedList,
        setDeviceSelectedList,
        showOverlay,
        setShowOverlay,
        isValid,
        setIsValid,
        firstClickOnMap,
        setFirstClickOnMap,
        toRegisterDays,       // Function to register selected days
        isValidCloseTime
    } = props;

    const { handleCreate,goBack } = CreateCafeteriaApp({
        t,                    // i18n translation function
        item,                 // Cafeteria form data (model)
        setItem,
        setEmptyFields,       // Callback to set empty fields warning
        navigate,             // React router navigation
        dispatch,             // Redux dispatch function
        deviceSelectedList,   // List of selected devices for the cafeteria
        toRegisterDays,       // Function to register selected days
        setShowOverlay,       // Callback to toggle overlay visibility
        setFirstClickOnMap    // Callback to control map interaction
    });

    return (<>
        <HeadTittle onBack={goBack} name={'create'}/>
        <DivContainerBody>
            <>
                <StepperTabs id={null} disabled={false} steps={steps} activeStep={activeStep} isStepOptional={step=> step === 1}
                    setActiveStep={setActiveStep} handleStepChange={handleStepChange}
                >
                    <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                        <div className='row'>
                            <CafeteriaFields
                                item={item}
                                disabled={disabled}
                                emptyFields={emptyFields}
                                handleChange={handleChange}
                                errorCode={errorCode}
                                errorName={errorName}
                                statusList={getListStatus}
                                isValid={isValid}
                            />
                        </div>
                        <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                            <ButtonNextStep
                                id='btn_cc_next_location'
                                text='next'
                                click={() => {
                                    if (!item.isValidSetUpData()) {
                                        setEmptyFields(true);
                                        return false;
                                    }
                                    if(!item.isValidCapacity()){
                                        setIsValid(false);
                                        return false;
                                    }
                                    setEmptyFields(false);
                                    setIsValid(true);
                                    setActiveStep((prevStep) => prevStep + 1)
                                }}
                            />
                        </div>
                    </StepTab>
                    <StepTab index={1} activeStep={activeStep} normalHeight={true}>
                        {
                            activeStep === 1 &&
                            <CafeteriaMap
                                item={item}
                                setItem={setItem}
                                disabled={disabled}
                                handleChange={handleChange}
                                showOverlay={showOverlay}
                                setShowOverlay={setShowOverlay}
                                firstClickOnMap={firstClickOnMap}
                            />
                        }

                        <div className='d-flex justify-content-between px-0 mt-3'>
                            <ButtonPrevStep
                                id='btn_cc_back_fields'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cc_next_access'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => setActiveStep((prevStep) => prevStep + 1)}
                            />
                        </div>
                    </StepTab>
                    <StepTab index={2} activeStep={activeStep} normalHeight={true}>
                        <div className={"row"}>
                            <CafeteriaAccess
                                item={item}
                                emptyFields={emptyFields}
                                disabled={disabled}
                                handleChange={handleChange}
                                dayArray={dayArray}
                                setDayArray={setDayArray}
                                deviceList={deviceList}
                                setDeviceList={setDeviceList}
                                deviceSelectedList={deviceSelectedList}
                                setDeviceSelectedList={setDeviceSelectedList}
                                isValidCloseTime={isValidCloseTime}
                            />
                        </div>

                        <div className='d-flex justify-content-between px-0 mb-2'>
                            <ButtonPrevStep
                                id='btn_cc_back_location'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cc_next_access'
                                text='next'
                                click={() => {
                                    if(!item.isValidAccessData(dayArray) || !isValidCloseTime){
                                        setEmptyFields(true);
                                        return;
                                    }
                                    setActiveStep((prevStep) => prevStep + 1)
                                }}
                            />
                        </div>
                    </StepTab>
                    <StepTab index={3} activeStep={activeStep} normalHeight={true}>
                        {activeStep === 3 &&
                            <CafeteriaSummary
                                item={item}
                                deviceSelectedList={deviceSelectedList}
                                dayArray={dayArray}
                            />
                        }

                        <div className='d-flex justify-content-between px-0 mb-2'>
                            <ButtonPrevStep
                                id='btn_cc_back_access'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cc_create'
                                text='create'
                                click={() => {
                                    handleCreate();
                                }}
                            />
                        </div>
                    </StepTab>
                </StepperTabs>
            </>
        </DivContainerBody>
    </>)
}

export default CreateCafeteria;
